import { Stack, Typography } from '@customink/pigment-react';
import { OrderSummary } from '~/adapters/services/accounts/orders/types';
import { formatDate } from '~/adapters/date/date';
import { styled } from '@customink/pigment-react/lib/themeCustomink';
import { moneyFormat } from '~/components/Money/money';
import { InterpunctedText } from '~/adapters/friendlyString/stringFormatter';

interface OrderCardSummaryInfoProps {
    order: OrderSummary;
}

const StyledTypography = styled(Typography)(({ theme }) => ({
    paddingBottom: theme.spacing(1),
    paddingTop: '0px',
}));

export function OrderCardSummaryInfo({ order }: OrderCardSummaryInfoProps) {
    return (
        <Stack direction="column" flexGrow={1} justifyContent="center">
            {order.deliveredAt && (
                <StyledTypography variant="heading4" weight="bold">
                    {InterpunctedText([`Delivered ${formatDate(order.deliveredAt)}`])}
                </StyledTypography>
            )}
            <Typography variant="uiTextSmall">
                {InterpunctedText([`Placed ${formatDate(order.placedAt)}`, `#${order.id}`])}
            </Typography>
            <Typography variant="uiTextSmall">
                {InterpunctedText([order.designName, `Qty: ${order.quantity}`, moneyFormat(Number(order.totalPrice))])}
            </Typography>
        </Stack>
    );
}

export default OrderCardSummaryInfo;
